// extracted by mini-css-extract-plugin
module.exports = {"sportFacts":"sport-facts-module--sportFacts--WRyJT","sportFactsLinkedItem":"sport-facts-module--sportFactsLinkedItem--QNtjF"};